import React, { useState } from "react";
import Fab from '@mui/material/Fab';
import GetApp from '@mui/icons-material/GetApp';
import Snackbar from '@mui/material/Snackbar';

export default function PwaButton() {
    const [state, setState] = useState(false);
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };
    
    window.addEventListener('load', (event) => {
        ///   console.log("PWA listened started")
        let deferredPrompt;
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            deferredPrompt = e;
            showInstallPromotion();
         ///   console.log('PWA was prompt should be enabled!');
        });

        let buttonInstall = document.getElementById("pwa")
        buttonInstall.addEventListener('click', async () => {
            if (window.navigator.userAgent.indexOf('Android') !== -1){
                window.location.replace('https://play.google.com/store/apps/details?id=app.web.edsala.twa');   
            }
            else{
                hideInstallPromotion();
                deferredPrompt.prompt();
                const outcome  = await deferredPrompt.userChoice;
                console.log(`User response to the install prompt: ${outcome}`);
                deferredPrompt = null;
            }
        });

        window.addEventListener('appinstalled', () => {
            hideInstallPromotion();
            deferredPrompt = null;
            handleOpen();
         ///   console.log('PWA was installed!');
        });
    });

    function showInstallPromotion() {
        setState(true);
      ///  console.log("PWA Install prompt: enabled");
    }
    function hideInstallPromotion() {
      ///  console.log("PWA Install prompt: disbled");
        if (state !== false) {
            setState(false);
        }
    }

    return (
        <div id="pwa">
            {state !== false ?
                <Fab
                    color="primary"
                    variant="extended"
                    className="secondary-form-button pwa-button"
                >
                    <GetApp />
                    Install
                </Fab> : ""}
            <Snackbar
                open={open}
                onClose={handleClose}
                message="Installing WebApp! Please, wait until it installs, then launch it from your home screen."
            />
        </div>
    );
}